import EventEmitter from './EventEmitter';

export default class Mouse extends EventEmitter {
    x = 0;
    y = 0;
    inComputer = false;
    isDown = false;

    constructor() {
        super();
    }
}
